import React, { useState } from "react";
import LayoutFooter from "../inc/LayoutFooter";
import LayoutHeader from "../inc/LayoutHeader";
import { useNavigate } from "react-router-dom";
import { RollbackOutlined, DeleteOutlined } from "@ant-design/icons";
import { Layout, Col, Row } from "antd";
import { Button, Card, Form, Spin, Badge, Avatar, Input } from "antd";
import { displayMessage, postAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { CREATE_GALLERY, IMAGE_BASE_URL } from "../../constants/api";
import ImageSelect from "../images/ImageSelect";

function GalleryAdd() {
  const { Content } = Layout;
  let history = useNavigate();
  let navigate = useNavigate();

  const [form] = Form.useForm();
  const [loading, setIsLoading] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  // For Image Selection
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedFileValue, setSelectedFileValue] = useState(null);
  const openDialog = () => {
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
  };

  const handleDialogOk = (selectedImage) => {
    if (selectedImage.length > 0) {
      setSelectedImage(selectedImage[0].id);
      setSelectedFileValue(selectedImage[0].filePath);
      form.setFieldsValue({ image: selectedImage[0].filePath });
      // console.log(selectedImage);
      // displayMessage(
      //   SUCCESS_MESSAGE,
      //   `Image ID: ${selectedImage[0].id}, Path: ${selectedImage[0].filePath}`
      // );
    } else {
      displayMessage(ERROR_MSG_TYPE, "Image not selected");
    }
  };

  const removeSelectedImage = () => {
    setSelectedImage("");
    setSelectedFileValue(null);
    form.setFieldsValue({ image: "" });
  };

  const createData = (values) => {
    setIsLoading(true);
    const data = new FormData();
    data.append("title", values.title);
    data.append("description", values.description);
    if (selectedImage) {
      data.append("image", selectedImage);
    }
    const successFn = function (data) {
      if (data.status === true) {
        setIsLoading(false);
        history("/gallery");
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setIsLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setIsLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Save Data");
    };
    postAPI(CREATE_GALLERY, data, successFn, errorFn);
  };
  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card
            title="Create Gallery"
            bordered={false}
            extra={
              <Button
                style={{
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
                onClick={() => navigate(-1)}
                type="primary"
                ghost
              >
                <RollbackOutlined />
              </Button>
            }
          >
            <Spin spinning={loading}>
              <Form form={form} layout="vertical" onFinish={createData}>
                <Row gutter={[16, 16]}>
                  <Col span={6}>
                    <Form.Item
                      name="title"
                      label="Title"
                      rules={[{ required: true }]}
                    >
                      <Input type={"text"} placeholder="Title" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="description"
                      label="Description"
                      rules={[{ required: true }]}
                    >
                      <Input type={"text"} placeholder="Description" />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item
                      type="file"
                      name="image"
                      label="Image"
                      rules={[{ required: true }]}
                    >
                      <Row>
                        <Col span={selectedImage === "" ? 24 : 15} offset={0}>
                          <Input
                            type="text"
                            readOnly
                            onClick={openDialog}
                            value={
                              selectedImage === ""
                                ? "Click to upload image"
                                : selectedImage
                            }
                            name="myImage"
                            placeholder="Image"
                          />
                        </Col>

                        {selectedImage !== "" ? (
                          <Col span={3} offset={1}>
                            <Badge>
                              <Avatar
                                src={IMAGE_BASE_URL + selectedFileValue}
                                shape="circle"
                                size="default"
                              />
                            </Badge>
                            <DeleteOutlined onClick={removeSelectedImage} />
                          </Col>
                        ) : null}
                      </Row>
                    </Form.Item>
                  </Col>
                </Row>
                <Row spceber>
                  <Col span={24}>
                    <Form.Item
                      style={{ float: "right" }}
                      label=""
                      colon={false}
                    >
                      <Button loading={loading} block htmlType="submit">
                        Submit
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Spin>
          </Card>
        </Content>
        <LayoutFooter />
        <ImageSelect
          isOpen={isDialogOpen}
          onClose={closeDialog}
          onOk={handleDialogOk}
          fromMager={false}
        />
      </Layout>
    </>
  );
}
export default GalleryAdd;
